import { useQuery } from '@apollo/client';
import { GET_OFFICEUSERS, GET_OFFICEUSERSBY_ROLE, UserData } from '../services/getUsers';
import { sortUsersByIdDesc } from '../utils/usersUtils';

export interface UserDataResponse {
  getUsersByOfficeAndSiblings: UserData[];
  getUsersByOfficeAndSiblingsAndRole: UserData[];
}

interface UseUsersReturn {
  users: UserData[];
  loading: boolean;
  error: any;
  refetch: () => void;
}

/**
 * Hook to fetch users by office using GraphQL
 */
export function useOfficeUsers(officeIds?: string[]): UseUsersReturn {
  const { data, loading, error, refetch } = useQuery<UserDataResponse>(GET_OFFICEUSERS, {
    variables: { officeIds: officeIds && officeIds.length > 0 ? officeIds : [] },
    skip: !officeIds || officeIds.length === 0,
  });

  let users: UserData[] = [];

  if (data) {
    users = data.getUsersByOfficeAndSiblings || [];
    const sorted = sortUsersByIdDesc(users);
    users = sorted;
  }

  return { users, loading, error, refetch };
}

/**
 * Hook to fetch users by office and role using GraphQL
 */
export function useOfficeUsersByRole(
  officeIds?: string[],
  role?: string
): UseUsersReturn {
  const { data, loading, error, refetch } = useQuery<UserDataResponse>(GET_OFFICEUSERSBY_ROLE, {
    variables: {
      officeIds: officeIds && officeIds.length > 0 ? officeIds : [],
      role,
    },
    skip: !officeIds || officeIds.length === 0,
  });

  let users: UserData[] = [];

  if (data) {
    users = data.getUsersByOfficeAndSiblingsAndRole || [];
  }

  return { users, loading, error, refetch };
}